import React from "react";

export default function C_V_NUMBER({ value }) {
  const formatDisplayValue = (val) => {
    if (val === null || val === undefined || val === "") return "";
    const parts = val.toString().split(".");
    // Format thousands with dots
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    // Connect decimals with comma
    return parts.join(",");
  };

  const displayValue = formatDisplayValue(value);

  return (
    <span
      title={displayValue}
      style={{
        display: "block",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: "100%",
        lineHeight: "1.5",
        textAlign: "right", // Right align is crucial for numbers!
        paddingRight: "8px", // Little breathing room from the cell border
      }}
    >
      {displayValue}
    </span>
  );
}
